import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import apiClient from '../services/api';
import { useAuth } from '../contexts/AuthContext';
import { AuthResponse } from '../types/auth';
import './Login.css';

const Login: React.FC = () => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState<string | null>(null);
    const [isLoading, setIsLoading] = useState(false);

    const { login } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();

    // The intended destination or fallback to home
    const from = (location.state as any)?.from?.pathname || '/';

    useEffect(() => {
        const query = new URLSearchParams(location.search);
        if (query.get('expired')) {
            setError('您的登录身份已过期。请使用OA账号密码登录。');
            // Clean up the URL to avoid showing the message again on refresh
            window.history.replaceState({}, document.title, '/login');
        }
    }, [location.search]);

    const handleLogin = async (e: React.FormEvent) => {
        e.preventDefault();
        setError(null);
        setIsLoading(true);

        try {
            const formData = new URLSearchParams();
            formData.append('username', username);
            formData.append('password', password);

            const response = await apiClient.post<AuthResponse>('/api/v1/auth/signin', formData, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            });

            // Invoke AuthContext login
            login(response.data);

            // Redirect smoothly to previous location
            navigate(from, { replace: true });

        } catch (err: any) {
            console.error('Login Error:', err);
            // Generalize standard OAuth form error
            if (err.response?.status === 401 || err.response?.status === 400) {
                setError(err.response?.data?.detail || "用户名或密码错误");
            } else {
                setError('服务器连接错误，请稍后再试');
            }
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="login-container">
            <div className="login-card">
                <h2>登录</h2>
                <p>请使用OA账号</p>
                {error && <div className="login-error">{error}</div>}

                <form onSubmit={handleLogin} className="login-form">
                    <div className="form-group">
                        <label htmlFor="username">用户名</label>
                        <input
                            id="username"
                            type="text"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            required
                            placeholder="输入用户名"
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="password">密码</label>
                        <input
                            id="password"
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                            placeholder="输入密码"
                        />
                    </div>
                    <button type="submit" disabled={isLoading} className="login-button">
                        {isLoading ? '登录中...' : '登 录'}
                    </button>
                </form>
            </div>
        </div>
    );
};

export default Login;
